import WorkOrderIndex from '@/views/comceptum/workorders/Index'
import WorkOrderDetail from '@/views/comceptum/workorders/Detail'
import WorkOrderForm from '@/views/comceptum/workorders/Form'

import ExportTimesIndex from '@/views/comceptum/export-times/Index'

export default
[
    {
        name:`comceptum:index`,
        path:`/comceptum`,
        component: {
            template: '<div><router-view /></div>'
        },
        children: [
            {
                name:`workorders:index`,
                path:`workorders`,
                component: WorkOrderIndex
            },
            {
                name:`workorders:create`,
                path: `workorders/create`,
                component: WorkOrderForm
            },
            {
                name:`workorders:update`,
                path: `workorders/:workOrderId/update`,
                component: WorkOrderForm
            },
            {
                name:`workorders:copy`,
                path: `workorders/:workOrderId/copy`,
                component: WorkOrderForm
            },
            {
                name: `workorders:detail`,
                path: `workorders/:workOrderId`,
                component: WorkOrderDetail
            },
            {
                name: `export-times:index`,
                path: `export-times`,
                component: ExportTimesIndex,
                meta: {
                    customPermission: 'workordertimes.read'
                }
            }
        ]
    }
]